import React from 'react';
import {RsnSkeleton} from '~/library/ui-kit';

export function OperationInfoSkeleton() {
    return (
        <>
            <div className='flex items-end justify-between gap-4'>
                <RsnSkeleton width={35} height={16} />
                <RsnSkeleton width={50} height={16} />
            </div>
            <div className='flex items-end justify-between gap-4'>
                <RsnSkeleton width={50} height={16} />
                <RsnSkeleton width={80} height={24} />
            </div>
        </>
    );
}
